import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  selectCategoriesIsLoading,
  selectCategoriesMap,
} from "../../../store/categories/categories.selector";
import ProductCard from "../../product-card/product-card.component";
import Spinner from "../../spinner/spinner.component";
import "./category.styles";
import { CategoryContainer, CategoryTitle } from "./category.styles";

type CategoryRouteParams = {
  category: string;
}

const Category = () => {
  const categoriesMap = useSelector(selectCategoriesMap);
  const { category } = useParams<keyof CategoryRouteParams>() as CategoryRouteParams;
  const [products, setProducts] = useState(categoriesMap[category]);
  const isLoading = useSelector(selectCategoriesIsLoading);

  useEffect(() => {
    setProducts(categoriesMap[category]);
  }, [category, categoriesMap]);

  return (
    <>
      <CategoryTitle>{category.toUpperCase()}</CategoryTitle>
      {isLoading ? (
        <Spinner />
      ) : (
        <CategoryContainer>
          {products &&
            products.map((product) => {
              return <ProductCard product={product} key={product.id} />;
            })}
        </CategoryContainer>
      )}
    </>
  );
};

export default Category;
